import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface ModuleProtectedRouteProps {
    children: React.ReactElement;
    moduleName: string;
}

const ModuleProtectedRoute: React.FC<ModuleProtectedRouteProps> = ({ children, moduleName }) => {
    const { loading, modulosAcessiveis } = useAuth();
    const location = useLocation();

    if (loading || modulosAcessiveis === null) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // console.log('ModuleProtectedRoute:', { loading, modulosAcessiveis, moduleName });

    if (!modulosAcessiveis || !modulosAcessiveis.includes(moduleName)) {
        // User does not have access to this module, redirect to dashboard or show an access denied message
        // For now, redirect to dashboard
        return <Navigate to="/" state={{ from: location, message: `Acesso negado ao módulo: ${moduleName}` }} replace />;
    }

    return children;
};

export default ModuleProtectedRoute;
